import { Fragment, ReactNode } from 'react';
import { DEFAULT_META_LIST_STYLES, MetaListStyles } from './metaListStyles';

interface MetaListProps {
  parts: readonly ReactNode[];
  styles?: MetaListStyles;
}

export const MetaList = ({ parts, styles = DEFAULT_META_LIST_STYLES }: MetaListProps) => (
  <span css={styles.root}>
    {parts.map((part, index) => (
      <Fragment key={`${part}-${index}`}>
        {index > 0 ? <span css={styles.separator}></span> : null}
        {part}
      </Fragment>
    ))}
  </span>
);
